import React from "react";

import { TransshipmentProvider } from "../../../../../../context/TransshipmentContext";
import TransshipmentTabs from "./Tabs";

const TransshipmentMaintenance = () => {
  return (
    <TransshipmentProvider>
      <TransshipmentTabs />
    </TransshipmentProvider>
  );
};

export default TransshipmentMaintenance;
